import React, { useState } from "react";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import PhotoCamera from "@mui/icons-material/PhotoCamera";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Badge from "@mui/material/Badge";
import CircularProgress from "@mui/material/CircularProgress"; // Import CircularProgress
import { styled } from "@mui/material/styles";
import { useUserContext } from "../../../context/UserContext";

const StyledBadge = styled(Badge)(({ theme }) => ({
  "& .MuiBadge-badge": {
    right: 12,
    bottom: 12,
    backgroundColor: "rgba(0,0,0,0.6)",
    color: "white",
    boxShadow: "0 0 0 2px white",
    width: 30,
    height: 30,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    "& svg": {
      fontSize: 18,
    },
  },
}));

const ProfilePictureUploader = () => {
  const { selectedUserDetail, uploadAvatar, avatarUrl, avatarLoading } =
    useUserContext() || {};

  const [localPreviewUrl, setLocalPreviewUrl] = useState(null);

  const { firstName, lastName, email } = selectedUserDetail || {};

  const handleFileChange = (event) => {
    const file = event?.target?.files?.[0];
    if (file) {
      setLocalPreviewUrl(URL.createObjectURL(file));
      uploadAvatar(email, file);
    }
  };

  const initials = `${firstName ? firstName.charAt(0) : ""}${
    lastName ? lastName.charAt(0) : ""
  }`;

  const displayUrl = localPreviewUrl || avatarUrl;

  return (
    <div>
      <input
        accept="image/*"
        id="icon-button-file"
        type="file"
        style={{ display: "none" }}
        onChange={handleFileChange}
      />
      <label htmlFor="icon-button-file">
        <StyledBadge
          overlap="circular"
          anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
          badgeContent={<PhotoCamera />}
        >
          <IconButton color="primary" component="span" sx={{ p: 0 }}>
            <Avatar
              src={displayUrl}
              sx={{
                width: 100,
                height: 100,
                cursor: "pointer",
                fontSize: 40,
              }}
            >
              {avatarLoading ? (
                <CircularProgress color="inherit" />
              ) : displayUrl ? (
                initials
              ) : (
                <AccountCircleIcon sx={{ fontSize: 100 }} />
              )}
            </Avatar>
          </IconButton>
        </StyledBadge>
      </label>
    </div>
  );
};

export default ProfilePictureUploader;
